export const mostSearchedKeywords = [
  'Pestañas',
  'Cejas',
  'Uñas',
  'Maquillaje',
  'Depilación',
  'Extensiones',
  'Corte',
  'Alisado',
  'Keratina',
  'Masajes'
];
